import AbstractCommand from "../../../core/application/AbstractCommand";
import KeyDecisionContentEvent from "../event/KeyDecisionContentEvent";
import KeyDecision from "../model/KeyDecision";
import KeyDecisionsConfig from "../model/KeyDecisionsConfig";
import KeyDecisionsModel from "../model/KeyDecisionsModel";

export default class KeyDecisionContentAvailableCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {KeyDecisionsModel} keyDecisionsModel 
     * @param {KeyDecisionsConfig} keyDecisionsConfig 
     */
    constructor(dispatcher, keyDecisionsModel, keyDecisionsConfig) {
        super(dispatcher);

        this._keyDecisionsModel = keyDecisionsModel;
        this._keyDecisionsConfig = keyDecisionsConfig;
    }

    execute(evt) {
        /** @type {KeyDecisionContentEvent} */
        const data = evt.params.data;
        const keyDecisionContent = data.content;
        const keyDecisionContentPlayer = data.contentPlayer;

        const keyDecisionDefinition = this._keyDecisionsConfig.getKeyDecisionDefinitionByContent(keyDecisionContent);

        console.log(`[KeyDecisionContentAvailableCommand] Key decision with content id '${keyDecisionContent.getContentID()}' becomes available.`);

        const keyDecision = new KeyDecision(keyDecisionDefinition, keyDecisionContent, keyDecisionContentPlayer);
        this._keyDecisionsModel.makeKeyDecisionAvailable(keyDecision);
    }
}